import { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";

const CustomModal = ({ title, mordernDesign, sidepanelWidth, hideImage = false, secondaryTitle = "", isOpen = false, size = "md", onCancel = () => { }, onClose = null, children, hideCrossIcon = false }) => {
  const [show, setShow] = useState(false);
  const device = useDevice();

  useEffect(() => {
    if (isOpen) {
      setShow(true);
    } else {
      const timeout = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  if (!isOpen && !show) return null;

  return (
    <div
      className={classNames("fixed left-0 overflow-hidden transition-opacity duration-300 w-full flex items-center justify-center", isOpen ? "opacity-100" : "pointer-events-none opacity-0", hideCrossIcon ? ((mordernDesign ? classNames(device === "desktop" ? "top-0 h-full z-30" : "top-16 h-[calc(100vh-4rem)]") : "top-16 h-[calc(100vh-4rem)] z-30")) : mordernDesign ? "top-0 h-full z-[60]" : "top-0 h-full z-[60]")}
      style={{ width: mordernDesign && hideCrossIcon && device === "desktop" ? `calc(100% - ${sidepanelWidth})` : "100%", marginLeft: mordernDesign && hideCrossIcon && device === "desktop" ? sidepanelWidth : "0" }}

    >
      <div className={classNames("px-4", mordernDesign && "relative z-0 flex w-full h-full items-center justify-center overflow-hidden")}>
        <div className={classNames("absolute left-0 top-0 z-[-1] h-full w-full transition-opacity duration-300", hideImage ? "bg-black" : "", isOpen ? "opacity-50" : "opacity-0")} />
        <div className={classNames("relative w-full min-w-96 sm:min-w-[36rem] md:min-w-[48rem] lg:min-w-[64rem] max-w-5xl transform rounded-lg bg-white shadow-lg transition-all duration-300 ease-in-out", isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0")}>
          <div className="flex h-16 flex-shrink-0 items-center justify-between border-b px-6">
            {title && (
              <h3 className="text-xl font-semibold text-gray-900">
                {title}
                {secondaryTitle && <span className="text-gray-400"> / {secondaryTitle}</span>}
              </h3>
            )}
            {!hideCrossIcon && (
              <button
                type="button"
                className="ml-auto text-gray-400 hover:text-gray-600 focus:outline-none"
                onClick={onClose ? onClose : onCancel}>
                <XMarkIcon className="h-6 w-6" />
              </button>
            )}
          </div>
          <div className="scrollbar max-h-[calc(100vh-12rem)] overflow-y-auto overflow-x-hidden p-4 pt-2">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
